import {AppStoreState} from 'src/store/interface';
import {NotificationStoreState} from './reducer';

export const getNotify = (state: AppStoreState): NotificationStoreState => {
  return state.notify;
};
